// removed by extract-text-webpack-plugin
module.exports = {"iconCleaning":"_1M7QSrCV9onxaEhsYiY2jF","iconCloudy":"_2ndrjGVTp3FO-iJNzahRkO","corn":"_2rYXlYNRZYv69OX4CWANNf","iconDrying":"_2BLRMr8A1Q4nQG4tu4w50w","iconInput":"BsoLtAC213-sTWC0vFi1h","iconOutput":"_3ebUsE2CNa0UdSjKwvsOMQ","iconRain":"_372YDRwxItppJVLsHWytyc","rape":"_298Ey8M9472r8uHZHPsNbM","iconRoce":"v5ln2lzoeTm4hxHoBtdua","soy":"_1B2EsdjZTgdM3OpXjMVB17","iconStoring":"_1-8aIdErp0uKC1Bo-eN-Op","sunflower":"nqkbCgyLr1DtHDP0XgpZs","iconSunny":"_1VbikakIgclvvq53FDDqCB","iconTranshipment":"_19k6Ur48a6o9dwPb1hIeTB","wheat":"sHMqQhJdTkbvfiTgBVVUx","iconPlay":"_3QBzI5F_TaP9Foc25-5yBm","iconPause":"_2JJ9lOWYIQTq_S30dgCsBs"};


//////////////////
// WEBPACK FOOTER
// ./src/iconfonts.css
// module id = 5
// module chunks = 0